import React from "react";
import "./PayTable.scss";
import {useTranslation} from "react-i18next";

function PayTable({ roundID }) {
  const {t} = useTranslation();

  return (
    <div className="pay-table">
      <div className="pay-table-round-number results-light">{`${t('round').toUpperCase()} #${roundID}`}</div>
      <div>
        <div className="results-box first">
          <h3 className="results-title">{t('pay table').toUpperCase()}</h3>
        </div>

        <div className="pay-table-item">
          <div className="pay-table-item-name">{t('number').toUpperCase()}</div>
          <div className="pay-table-item-value">X 36</div>
        </div>

        <div className="pay-table-item">
          <div className="pay-table-item-name">{t('colors').toUpperCase()}</div>
          <div className="pay-table-item-value">
            <div>X 36</div>
            <div>X 2</div>
          </div>
        </div>

        <div className="pay-table-item">
          <div className="pay-table-item-name">
            {t('sector').toUpperCase()} <small>(A/B/C/D/E/F)</small>
          </div>
          <div className="pay-table-item-value">X 6</div>
        </div>

        <div className="pay-table-item">
          <div className="pay-table-item-name">
            {t('dozens').toUpperCase()} <small>(1-12/13-24/25-36)</small>
          </div>
          <div className="pay-table-item-value">X 3</div>
        </div>

        <div className="pay-table-item">
          <div className="pay-table-item-name">{t('even odd').toUpperCase()}</div>
          <div className="pay-table-item-value">X 2</div>
        </div>
      </div>
    </div>
  );
}

export default PayTable;
